import bugsnag from '@bugsnag/js'; // initialize bugsnag ASAP, before other imports

const bugsnagClient = bugsnag({
  apiKey: 'ebbaf5318f1db8ec0aba4b135e232f14',
  notifyReleaseStages: ['production', 'staging'],
});

export { bugsnagClient };
